/**
 * @module mapbs.components.citymodel3d.citymodel3dbutton.citymodel3dbutton
 */
import angular from 'angular';
import mapbsCitymodel3dService from 'mapbs/components/citymodel3d/citymodel3dservice/citymodel3dservice';
import ngeoMiscToolActivate from 'ngeo/misc/ToolActivate.js';
import olInteractionDraw from 'ol/interaction/Draw.js';

const moduleCitymodelbutton = angular.module('mapbsCitymodel3dbutton', [
    mapbsCitymodel3dService.name,
]);

/**
 * @return {angular.Directive} The directive specs.
 */
const mapbsCitymodel3dDirective = function () {
    return {
        restrict: 'A',
        controller: 'mapbsCitymodel3dbuttonController as btn3dCtrl',
        bindToController: {
            map: '<mapbsCitymodel3dbuttonMap',
            scaleValues: '<mapbsCitymodel3dbuttonScalevalues',
            active: '<?mapbsCitymodel3dbuttonActive',
            mapcenter: '<?mapbsCitymodel3dbuttonMapcenter',
            startingMap: '<mapbsCitymodel3dbuttonStartingmap',
        },
    };
};

moduleCitymodelbutton.directive('mapbsCitymodel3dbutton', mapbsCitymodel3dDirective);

class citymodel3dbuttonController {
    /**
   * @param {!angular.Scope} $scope
   * @param {import("ngeo/misc/ToolActivateMgr.js").ToolActivateMgr} ngeoToolActivateMgr
   * @param {mapbs/component/citymodel3d/citymodel3dservice/citymodel3dservice} mapbsCitymodel3dService
   * @param {angular.Attributes} $attrs Attributes
   * @constructor
   * @ngInject
   */
    constructor($scope, ngeoToolActivateMgr, mapbsCitymodel3dService, $attrs) {
        this.scope = $scope;

        /** @type {mapbs/component/citymodel3d/citymodel3dservice/citymodel3dservice} */
        this.citymodel3dService = mapbsCitymodel3dService;

        /** @type {ol.Map} */
        this.map;

        /** @type {Array.<number>} */
        this.scaleValues;

        /** @type {boolean} */
        this.active;

        /** @type {string} */
        this.startingMap;

        /** @type {boolean} */
        this.mapcenter = $attrs['mapbsCitymodel3dbuttonMapcenter'] === 'true';

        ngeoToolActivateMgr.registerTool(
            'mapTools',
            new ngeoMiscToolActivate(this, 'active'),
            false
        );

        if (!this.mapcenter) {
            this.initializeMapInteraction();

            this.citymodel3dDrawInteraction.on('drawend', (event) => {
                const coord = event.feature
          .getGeometry()
          .transform('EPSG:2056', 'EPSG:4326')
          .getCoordinates();
                this.openUrl(coord[0], coord[1], this.scaleValues);
            });
        }
    }

    openUrl(easting, northing, scaleValues) {
        this.citymodel3dService
      .getUrl(easting, northing, scaleValues, this.startingMap)
      .then((url) => {
          window.open(url, this.target);
      });
    }

    initializeMapInteraction() {
        this.citymodel3dDrawInteraction = new olInteractionDraw({
            type: /** @type{ol.geom.GeometryType} */ ('Point'),
        });

        this.scope.$watch(
            () => this.active,
            (newVal) => {
                if (newVal) {
                    this.map.addInteraction(this.citymodel3dDrawInteraction);
                } else {
                    this.map.removeInteraction(this.citymodel3dDrawInteraction);
                }
            }
        );
    }
}

moduleCitymodelbutton.controller(
    'mapbsCitymodel3dbuttonController',
    citymodel3dbuttonController
);

export default moduleCitymodelbutton;
